export default class Observer {
  constructor (target, config, type) {
    this.target = target
    this.config = config
    this.type = type
  }

  observe (cb) {
    const obs = new MutationObserver(mutationList => {
      for (const mutation of mutationList) {
        mutation.type === this.type ? cb(mutation) : null
      }
    })
    
    obs.observe(this.target, this.config)
  }
}


// WEBPACK FOOTER //
// ./src/utils/observer.js